import styled, { css } from 'styled-components';
import * as ChartAnalysisTableUI from '../../ChartAnalysisTable/ChartAnalysisTableUI';
import SearchInput from '../../../Form/SearchInput';
import { theme } from '../../../../styles/theme';

export const HeaderCell = styled.div<{ $columnIndex: number }>`
  padding: 8px;
  border-top: 1px solid ${theme.colors.border};
  border-right: 1px solid ${theme.colors.border};
  border-bottom: 1px solid ${theme.colors.border};
  border-left: ${({ $columnIndex }) =>
    $columnIndex === 0 ? `1px solid ${theme.colors.border}` : 0};
  font-size: 12px;
  font-weight: 600;
  color: ${theme.colors.secondary900};
  cursor: pointer;
  user-select: none;
  background-color: ${theme.colors.tableHeader};
`;

export const Subheader = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${theme.colors.secondary800};
`;

export const Cell = styled.div<{
  $rowIndex: number;
  $columnIndex: number;
  $isDisabled?: boolean;
  $backgroundColor?: string;
  $color?: string;
  $isFixedCell?: boolean;
  $isClickable?: boolean;
}>`
  position: relative;
  border-top: ${({ $rowIndex }) =>
    $rowIndex === 0 ? `1px solid ${theme.colors.border}` : 0};
  border-left: ${({ $columnIndex }) =>
    $columnIndex === 0 ? `1px solid ${theme.colors.border}` : 0};
  border-right: 1px solid ${theme.colors.border};
  border-bottom: 1px solid ${theme.colors.border};

  font-size: 12px;
  font-weight: 500;
  color: ${({ $color }) => $color || theme.colors.secondary800};

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: ${({ $rowIndex }) =>
    $rowIndex % 2 === 0 ? theme.colors.level1 : theme.colors.level2};
  padding: 8px 7px;

  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    color: ${theme.colors.secondary400};
  `};

  ${({ $backgroundColor }) =>
    $backgroundColor &&
    `
    color: ${theme.colors.secondary900};
    font-weight: 600;
    background-color: ${$backgroundColor};
  `};

  ${({ $isFixedCell }) =>
    $isFixedCell &&
    `
    font-weight: 600;
  `};

  ${({ $isClickable }) =>
    $isClickable &&
    css`
      cursor: pointer;
      color: ${theme.colors.mainBlue};
      font-weight: 600;
      text-decoration: underline;
    `};
`;

export const InfinityContainer = styled.div`
  font-size: 16px;
  font-weight: 600;
`;

export const TableHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 100%;
  align-items: center;
  column-gap: 4px;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SearchInputContainer = styled.div`
  display: flex;
  column-gap: 8px;
  align-items: center;
`;
export const SearchResultText = styled.div`
  font-size: 12px;
`;

export const TableColumnResizeHandle = styled(
  ChartAnalysisTableUI.ChartColumnResizeHandle,
)`
  height: 48px;
`;

export const StyledSearchInput = styled(SearchInput)`
  flex: 0 0 auto;
  width: 240px;
`;
